import { useEffect } from 'react'
import Scrollbars from 'react-custom-scrollbars'
import styled from 'styled-components'
import DOMPurify from 'dompurify'
export const PrivacyPolicy = props => {
  const { data, privacy } = props
  return (
    <LoginContainer>
      <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(privacy) }} />
      {/* <div>
        <p className="topic">导言</p>
      </div>
      <div className="text">
        为了说明上海矢安科技有限公司（以下称“矢安科技”或“我们”）向您提供的服务，也为了让您了解我们将如何收集、使用、存储和分享您的个人信息以及您所享有的权利，我们将通过本《隐私政策》（以下称“本政策”）向您说明相关事宜。
      </div>
      <div className="text">
        我们深知个人信息保护的重要性，并将按照法律法规的规定，尽最大努力保护您的个人信息安全，且将恪守以下原则：权责一致原则、目的明确原则、选择同意原则、最小必要原则、确保安全原则、主体参与原则、公开透
        明原则等。同时，我们承诺，我们将按业界成熟的安全标准，采取相应的安全保护措施来保护您的个人信息。在您使用我们提供的产品/服务时，我们将按本政策收集、存储、分析、传输、使用、处理及保护您的个人信息。
        为了保证对您个人信息合法、合理、正当的收集、使用，并在安全、可控的前提下进行存储、分析、传输、处理等，我们制定本政策，您在使用我们的产品/服务时，请仔细阅读并了解本政策。如您在使用我们提供的产品/
        服务时，主动勾选或点击“同意”本政策或以其他方式明确选择同意本政策，即意味着您同意本政策的条款，并同意我们按照本政策来收集、存储、分析、传输、使用、处理、共享您的相关信息。
      </div>
      <div className="text">
        我们会遵循本政策收集、存储、分析、传输、使用、处理您的信息，但不会仅因您同意本政策而采用强制捆绑的方式一揽子收集个人信息。当您使用或开启相关功能或使用服务时，我们会收集、使用为实现该功能或服务所
        必要的信息。除非是为实现基本业务功能或根据法律法规要求所必需的信息，您均可以拒绝提供。
      </div>
      <div className="title">如您想详细了解本政策的相关信息，可根据以下指引阅读相应的章节：</div>
      <ul>
        <li>一、我们如何收集和使用信息</li>
        <li>二、我们如何使用Cookie</li>
        <li>三、我们如何共享、转让、公开披露信息</li>
        <li>四、信息的安全保护及存储</li>
        <li>五、您的权利</li>
        <li>六、未成年人使用条款</li>
        <li>七、隐私政策的生效和变更</li>
        <li>八、其他</li>
        <li>九、定义</li>
      </ul>
      <div className="title">一、我们如何收集和使用信息</div>
      <div className="text">
        您在使用我们提供的服务的过程中，我们将按照以下目的，收集和使用您在使用服务时主动提供或因使用服务产生的信息：
      </div>
      <div className="second-title">1. 帮助您完成注册与登录</div>
      <div className="text">
        您在使用我们的业务功能时，为便于我们向您提供专门的服务，您需要提供您的电子邮箱、姓名、手机号码、公司名称、公司所在行业等基本信息，并创建您的账号、用户名和密码。如您拒绝提供，则无法使用我们提供的
        相关产品或/和服务。
      </div>
      <div className="second-title">2. 维护基础功能的正常运行</div>
      <div className="text">
        <p className="text">
          为保障您在使用我们的服务过程中的账户与系统运行安全，识别账号异常，防范钓鱼网站欺诈，以及维护基础功能的正常运行，您理解并同意我们自动收集、保存您使用服务以及使用方式的相关信息，该等信息包括：
        </p>
        <p className="text">
          （1）日志信息：我们可能会自动收集您使用我们服务的详细情况，并作为网络日志进行保存，包括您曾访问的页面、浏览器类型等。
        </p>
        <p className="text">
          （2）设备信息：我们可能会根据您使用我们网站服务或使用产品中的具体权限授权，采集并保存您所使用设备的相关信息，包括IP地址、操作系统信息等。
        </p>
      </div>
      <div className="second-title">3. 提供风险识别服务</div>
      <div className="text">
        我们会收集您的部分设备信息（包括设备指纹、面部识别、登录IP地址等，并映射为地理位置），并使用数据和访问数据对比分析，以实现识别风险、拦截账号盗用风险。
      </div>
      <div className="second-title">4. 其他用途</div>
      <div className="text">
        我们可能将您的个人信息用于我们合法开展并向您提供的其他矢安科技业务服务中。如我们将您的个人信息用于本政策未载明的其他用途或变更处理方式，我们会通过页面提示、交互流程、网站公告或其他方式依法另行征得您的同意。一旦获得您的同意，该等额外用途将视为本政策的一部分，该等额外信息也将适用本政策。
      </div>
      <div className="second-title">5. 关于个人敏感信息的提示</div>
      <div className="text">
        以上由您提供或我们被授权收集的信息中，可能包含您的个人敏感信息。您同意，我们可以按照本政策所声明的目的和方式处理相关个人敏感信息。同时，我们也将按照法律法规以及监管的要求，对该等个人敏感信息进行特别的保护。
      </div>
      <div className="title">二、我们如何使用Cookie</div>
      <div className="text">
        为确保服务的正常运转，我们会在您的计算机或移动设备上存储名为
        Cookies的小数据文件。我们向您发送Cookie是为了简化您重复输入信息以登录账户的步骤、储存您的偏好设置，帮助判断您的登录状态以及账户或数据安全，目的是向您提供友好、安全的服务。Cookie
        通常包含标识符、站点名称以及一些号码和字符。借助于
        Cookie，我们会存储标识数据并在后续的服务中读取该标识。我们不会将
        Cookies用于本政策所述目的之外的任何用途。您可根据自己的偏好管理或删除Cookies。您可以清楚计算机上或移动设备上保存的所有Cookie，大部分网络浏览器都设有阻止Cookie的功能，您通常可根据自己的需求来修改浏览器的设置以拒绝Cookies，但如果您这么做，您可能需要在每一次访问矢安科技提供的产品/服务时亲自更改用户设置，可能会影响您安全访问和使用矢安科技提供的产品/服务。
      </div>
      <div className="title">三、我们如何共享、转让、公开披露信息</div>
      <div className="second-title">（一）共享</div>
      <div className="text">
        <p className="text">
          1.
          我们承诺会对您的信息进行保密。除法律法规及监管部门另有规定外，我们会按照本政策中所述的目的的范围内，与我们的关联公司共享必要的个人信息。
        </p>
        <p className="text">
          2.
          我们只在取得您的同意或授权后，才会与我们的合作伙伴及第三方共享相关个人信息。具体而言，在获得您的同意后，我们会根据所提供服务的必要，将相关个人信息与我们的合作伙伴及第三方共享。我们的合作伙伴
          或该第三方无权将共享的个人信息用于任何其他目的。如因业务需要，确需超出前述授权范围使用信息的，我们将再次征求您的授权或同意。
        </p>
        <p className="text">
          3.
          在将信息提供给第三方前，我们将尽商业上合理的努力评估该第三方收集信息的合法性、正当性、必要性，且我们会对我们的合作伙伴及第三方的数据安全能力进行调查，并要求合作伙伴及第三方采取必要的保密和安
          全措施来存储、使用和处理相关信息，确保相关信息不被泄露。
        </p>
      </div>
      <div className="second-title">（二）转让</div>
      <ul>
        <li>1. 除非获得您的明确授权或同意，我们不会将您的个人信息转让给任何第三方。</li>
        <li>
          2.
          您理解，随着我们业务的持续发展，我们将有可能进行合并、分立、解散、收购、资产转让或类似的交易、被宣告破产等，您的信息有可能作为此类交易的一部分而被转移。在发生前述变更时，我们将会向您告知接收
          方的名称或者姓名和联系方式等有关情况，并要求新的持有您或信息的公司、组织按照法律法规及不低于本政策所要求的安全标准继续保护您的信息。如变更相关信息使用目的时，我们将要求该公司、组织重新取得您的
          明确同意。
        </li>
      </ul>
      <div className="second-title">（三）公开披露</div>
      <div className="text">
        除非获得您的明确同意，或者基于法律法规、诉讼或政府监管部门的强制性要求，我们不会公开披露您的个人信息。在根据法律、法规的要求、强制性的行政执法或司法要求所必须提供您个人信息的情况下，我们可能会
        依据所要求的个人信息类型和披露方式披露您的个人信息。在符合法律法规的前提下，当我们收到上述披露信息的请求时，我们会要求必须出具与之相应的法律文件，如传票或调查函。我们坚信，对于要求我们提供的信
        息，应该在法律法规允许的范围内尽可能保持透明。我们对所有的请求都将进行慎重的审查，以确保其具备合法依据，且仅限于执法部门因特定调查目的且有合法权利获取的数据。
      </div>
      <div className="second-title">（四）共享、转让、公开披露个人信息时事先征得授权同意的例外</div>
      <ul>
        <li>
          在以下情形中，我们共享、转让或公开披露您或您的个人信息的，将无需事先征得您的授权同意：
        </li>
        <li>(1)您自行向第三方共享或向社会大众公开的；</li>
        <li>(2)与国家安全、国防安全、公共安全、公共卫生、公共利益直接相关的；</li>
        <li>
          (3)根据相关法律法规强制性要求所必须的情况下进行披露或提供，或与犯罪侦查、起诉、审判和判决执行等直接相关的。在符合法律法规的前提下，当我们收到前述披露信息的请求时，我们会要求对方必须出具与之相应的
          法律文件，如传票或调查函。我们将对所有的请求都进行审慎的审查，以确保其具备合法依据，且限于行政、司法部门因特定调查目的有合法权力获取的数据；
        </li>
        <li>
          (4)在法律法规允许的范围内，为维护我们其他客户、公司及其关联方的生命、财产等合法权益或维权产品或服务的安全所必需的，例如查找、预防、处理欺诈等违法活动和减少信用风险等；
        </li>
        <li>(5)从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；</li>
        <li>(6)根据您的要求签订或履行合同所必需的；</li>
        <li>
          (7)学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；
        </li>
        <li>(8)法律法规规定的其他情形。</li>
      </ul>
      <div className="title">四、信息安全保护及存储</div>
      <div className="second-title">（一）信息安全保护</div>
      <ul>
        <li>
          1.
          我们非常重视个人信息的安全，将努力采取各种符合业界标准的合理安全措施（包括技术方面和管理方面）来保护您的个人信息，防止您提供的个人信息被不当使用或被未经授权访问、公开披露、使用、修改、损坏、丢
          失或泄漏。
        </li>
        <li>
          2.
          我们会使用加密技术、匿名化处理等合理可行的手段保护相关个人信息，并使用受信赖的保护机制防止个人信息遭到恶意攻击。
        </li>
        <li>
          3.
          我们会建立专门的信息安全工作小组、安全管理制度、数据安全流程保障个人信息安全。我们采取严格的数据使用和访问制度，确保只有授权人员才可访问您的个人信息，并适时对数据和技术进行安全审计。
        </li>
        <li>
          4.
          尽管已经采取了上述合理有效措施，并已经遵守了相关法律规定要求的标准，但请您理解，由于技术的限制以及可能存在的各种恶意手段，在互联网行业，即便竭尽所能加强安全措施，也不可能始终保证信息绝对安全，
          我们将尽力确保您提供给我们的个人信息的安全性。您知悉并理解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。因此，我们强烈建议您采取积极措施保护个人信息的安全，包括
          但不限于使用复杂密码、定期修改密码、不将自己的账号密码及相关个人信息透露给他人。
        </li>
        <li>
          5.
          我们会制定应急处理预案，并在发生用户信息安全事件时立即启动应急预案，努力阻止任何安全事件的影响和后果扩大。一旦发生用户信息安全事件（泄露、丢失等）后，我们将按照法律法规的要求，及时向您告知：安
          全事件的基本情况和可能的影响、我们已经采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以推送通知、邮件、信函、短信等形式告知您，难以逐一告知时，
          我们会采取合理、有效的方式发布公告。同时，我们还将按照相关监管部门要求，上报用户信息安全事件的处置情况。
        </li>
        <li>
          6.
          我们谨此特别提醒您，本政策提供的个人信息保护措施仅适用于我们及关联方/合作方提供的相关服务。我们没有能力及义务保护您在相关服务之外的应用、网站提交的任何个人信息，无论您登录或浏览上述软件、网站是
          否基于我们的链接或引导，我们对此不承担任何法律责任。
        </li>
      </ul>
      <div className="second-title">（二）信息的存储</div>
      <div className="text">
        我们会按照法律法规规定，将在中华人民共和国境内收集的相关个人信息存储于中华人民共和国境内。如部分产品涉及跨境业务，我们需要向境外机构传输境内收集的相关个人信息的，我们会按照法律法规和相关监管部门
        的规定执行，并通过签订协议、现场核查等有效措施，要求境外机构确保您的个人信息安全。
      </div>
      <div className="title">五、您的权利</div>
      <ul>
        <li>
          1.
          我们非常重视您对个人信息的管理，并尽全力保护您对相关个人信息的修改（更新或更正）、删除以及撤回授权的权利。
        </li>
        <li>
          2.
          如您需修改（更新或更正）、删除或终止授权部分或全部信息，您可通过我们提供的服务邮箱support@asants.com与我们取得联系，并向我们提出书面申请。请理解，为保障安全，我们需要您提供相应的身份证明，并
          将会在核验申请者的身份后的合理期限内处理相应需求。如需申请删除个人信息或终止授权我们向您提供相关服务，我们将及时在我们系统删除相关个人信息，并不再向您提供相关服务，但终止授权的决定，不影响此前基
          于您的授权已开展的个人信息处理。
        </li>
        <li>3. 按照法律法规的要求，当相关信息存在以下任何一种情形时，我们可能无法响应您的请求：</li>
        <li>(1)与国家安全、国防安全有关的；</li>
        <li>(2)与公共安全、公共卫生、重大公共利益等有关的；</li>
        <li>(3)与犯罪侦查、起诉、审判和执行判决等有关的；</li>
        <li>(4)有充分证据表明您存在主观恶意或滥用权利的；</li>
        <li>(5)响应相关请求将导致您或其他个人、组织的合法权益受到严重损害的；</li>
        <li>(6)涉及商业秘密的；</li>
        <li>(7)其他法律法规规定的情形。</li>
      </ul>
      <div className="title">六、未成年人使用条款</div>
      <ul>
        <li>
          1.
          我们非常重视对未成年人个人信息的保护。若您是未满18周岁的未成年人，在使用我们提供的服务前，应在您的法定监护人的监护、指导下共同阅读并同意本政策。
        </li>
        <li>
          2.
          我们根据国家相关法律法规的规定保护未成年人的个人信息，只会在法律允许、父母或其他监护人明确同意或保护儿童所必要的情况下收集、使用或公开披露未成年人的个人信息。您及您的监护人应对您所提供信息的
          真实性负责，如我们无法从所获取的信息判断出您为未成年人，那么我们将不承担保护未成年人隐私权的责任。如您是未成年人的监护人，当您对您所监护的未成年人的个人信息有相关疑问时，请通过第八条中的联系方
          式与我们联系。
        </li>
      </ul>
      <div className="title">七、隐私政策的生效和变更</div>
      <ul>
        <li>
          1.
          本政策自您在向我们主动提供注册登录信息，或您在使用我们提供的内容安全检测或风控服务时起生效。
        </li>
        <li>
          2.
          为了给您提供更好的服务，相关服务将不时更新与变化，我们适时对本政策进行修订，该等修订构成本政策的一部分并具有等同于本政策的效力。但原则上我们不会削减您依据当前生效的本政策所应享受的权利。
        </li>
        <li>
          3.
          本政策更新后，我们会通过在我们官方渠道或其他适当的方式，展示本政策的具体变更内容，以便您及时了解本政策的最新版本，您理解并同意我们不需再向您作个别的通知。在前述情况下，若您继续使用我们的服务，
          即表示同意接受修订后的本政策并受之约束。
        </li>
      </ul>
      <div className="title">八、其他</div>
      <ul>
        <li>1. 本政策的标题仅为方便及阅读而设，并不影响本政策中任何规定的含义或解释。</li>
        <li>2. 矢安科技各方之间，独立且非连带地向您承担本协议所约定的义务及责任。</li>
        <li>
          3.
          如对本政策或其中有关您个人信息的收集、保存、使用、共享、披露、保护等功能存在意见或建议时，您可以通过我们反馈渠道反馈意见或投诉，并作充分描述，我们会在验证身份的15个工作日内答复您的请求并尽力
          解决。如对我们的答复不满意，尤其是认为我们处理个人信息的行为损害了您的合法权益，您可与我们协商解决。协商不成的，您还可向矢安科技住所地上海市浦东新区有管辖权的人民法院提起诉讼。
        </li>
        <li>
          4. 我们设立了个人信息保护的专门反馈渠道，您可以通过以下方式联系我们：服务邮箱
          support@asants.com。
        </li>
        <li>5. 本政策的版权为矢安科技所有，在法律允许的范围内，我们保留最终解释和修改的权利。</li>
      </ul>
      <div className="title">九、定义</div>
      <ul>
        <li>1. 相关服务：是指矢安科技产品服务，以用于支持安全性检测服务。</li>
        <li>
          2.
          关联方：是指因合作、投资或控制（或共同控制）关系而与我们产生任何联系的公司、组织或个人。
        </li>
        <li>3. 第三方：是指本政策约定的关联方范围以外的其他公司、组织或个人。</li>
        <li>4. 您：是指我们的产品和/或服务的注册用户以及相关服务的购买方。</li>
        <li>
          5.
          个人信息：是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。个人信息包括个人基本信息、个人身份信息、个人生物识别信息、网络身份标识
          信息、个人健康生理信息、个人教育工作信息、个人财产信息、个人通信信息、联系人信息、个人上网记录、个人常用设备信息、个人位置信息等。个人信息包括但不限于个人敏感信息。
        </li>
        <li>
          6.
          个人敏感信息：是指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息。个人敏感信息包括个人财产信息、个人健康生理信息、个人生物识别信息、
          个人身份信息、网络身份标识信息等。
        </li>
        <li>
          7. 去标识化：是指个人信息经过处理，使其在不借助额外信息的情况下无法识别特定自然人的过程。
        </li>
        <li>8. 匿名化：是指个人信息经过处理无法识别特定自然人且不能复原的过程。</li>
      </ul> */}
    </LoginContainer>
  )
}

const LoginContainer = styled.div`
  height: 570px;
  padding-right: 40px;
  overflow-y: scroll;
  ul,
  ol,
  li {
    list-style: none;
    margin: 8px 0;
    line-height: 21px;
    padding: 0;
  }
  .topic {
    width: 32px;
    height: 16px;
    font-size: 16px;
    width: 100%;
    margin-top: 14px;
    font-weight: 600;
    text-align: center;
    color: #333333;
    line-height: 24px;
  }
  .text {
    font-size: 14px;
    font-weight: 400;
    color: #333333;
    line-height: 22px;
    width: calc(100% - 20px);
    margin-bottom: 0;
  }
  .title {
    font-size: 14px;
    font-weight: 600;
    color: #333333;
    line-height: 24px;
  }
  .second-title {
    font-size: 14px;
    font-weight: 600;
    color: #333333;
    line-height: 21px;
  }
`
